import React from 'react';
import { clsx } from '../../utils/clsx';
export const ShopifyRichText = ({ items }) => React.createElement(React.Fragment, null, items.map((item, i) => {
    switch (item.type) {
        case 'paragraph':
            return React.createElement("p", { key: i },
                React.createElement(ShopifyRichText, { items: item.children }));
        case 'heading':
            return React.createElement(`h${item.level}`, { key: i }, React.createElement(ShopifyRichText, { items: item.children }));
        case 'link':
            return React.createElement("a", { key: i, href: item.url, target: item.target, title: item.title },
                React.createElement(ShopifyRichText, { items: item.children }));
        case 'list':
            return React.createElement(item.listType === 'ordered' ? 'ol' : 'ul', { key: i, className: 'pl:24' }, item.children.map((li, j) => React.createElement("li", { key: j },
                React.createElement(ShopifyRichText, { items: li.children }))));
        default:
            return React.createElement("span", { key: i, className: clsx(item.bold && 'fw:700', item.italic && 'text:italic') }, item.value);
    }
}));
